var map = {
	"./01.png": "c2b4",
	"./02.png": "c731",
	"./03.png": "4589",
	"./04.png": "5478",
	"./05.png": "6d4d",
	"./06.png": "454e",
	"./07.png": "46fe",
	"./08.png": "340d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "689f";